import React from 'react';
import * as fromProjects from 'store/Projects';

import { FullQuotation, IQuotation } from 'components/Quotations/FullQuotation/FullQuotation';

interface IProps {
  animationReady: boolean;
  content: fromProjects.IContentQuotationDefault;
  quotationBackgroundShade: fromProjects.IBackgroundShadeTypes;
}

export const Default: React.FC<IProps> = ({ animationReady, content, quotationBackgroundShade, ...props }) => {
  const quotationDetails: IQuotation = {
    name: content.name,
    title: content.title,
    quotation: <span>{content.quotation}</span>,
  };

  return (
    <FullQuotation
      class={'projectQuotation'}
      viewportOffsets={{
        top: 300,
        bottom: 300,
      }}
      quotation={quotationDetails}
      sectionBackgroundShade={quotationBackgroundShade}
      quotationMarkColor={content.quotationMarkColor}
      personLineColor={content.personLineColor}
      animationReady={animationReady}
    />
  );
};
